import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavigationService} from '@services/navigation-service';
import {Router} from '@angular/router';
import {MdDialog, MdDialogConfig, MdDialogRef} from '@angular/material';
import {AgrisAccesoRestringidoDialogComponent} from '../../agris';
import {environment} from '../../../../environments/environment';
import * as jwt_decode from 'jwt-decode';
import { CreditNotConfiguredDialogComponent } from '../../creditos/credit-not-configured-dialog/credit-not-configured-dialog.component';
import { PATH_CLIENTES, PATH_CLIENTES_ACOPIO } from 'app/navigation/navigation.module';
@Component({
  selector: 'app-side-menu-list-item',
  templateUrl: './side-menu-list-item.component.html',
  styleUrls: ['./side-menu-list-item.component.scss']
})
export class SideMenuListItemComponent implements AfterViewInit {

  @Input() menuItemObj: SideMenuItem = {} as SideMenuItem;
  @Output() onColapseAll = new EventEmitter<SideMenuItem>();
  isActiveRoute = false;

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private dialog: MdDialog
  ) { }

  ngAfterViewInit() {
    this.navigationService.$currentURL.subscribe(url => {
      this.isActiveRoute = this.menuItemObj.MainURL.some(urlOption => {
        return url.includes(urlOption);
      });
    });
  }

  onClickMain() {
    if (!this.menuItemObj.jdeAllowed) {
      let config = new MdDialogConfig();
      config.panelClass = 'dialog-pannel-custom';
      config.width = '343px';
      this.dialog.open(AgrisAccesoRestringidoDialogComponent, config);
      return;
    }

    if (this.menuItemObj.Subtree.length === 0) {
      if (!this.isActiveRoute) {
        if (this.menuItemObj.IsNewAngularURL) {
          if(this.menuItemObj.MainName === 'Créditos'){
            if(!this.checkCreditAccessPermissions()) this.openNewAngular(this.menuItemObj.MainURL[0]);
          }
         else {
            this.openNewAngular(this.menuItemObj.MainURL[0]);
          }
        } else {
          this.router.navigate([this.menuItemObj.MainURL[0]]);
        }
        this.onColapseAll.emit();
      }
      this.navigationService.toggleNav(false);
    } else {
      // sea cual sea la accion, cerramos los demas submenus
      this.onColapseAll.emit(this.menuItemObj)
      this.menuItemObj.open = !this.menuItemObj.open;
    }
  }

  onClickSubtree(item: SideMenuSubtreeItem) {
    if (!this.navigationService.currentURL.value.includes(item.URL)) {
      if (this.menuItemObj.IsNewAngularURL) {
          if (this.menuItemObj.MainName === 'Clientes') {
          this.openNewAngular(`${PATH_CLIENTES}/${PATH_CLIENTES_ACOPIO}/consolidado/seccion/${Number(item.id)}`)
        }else {
            this.openNewAngular(item.URL);
        }
      
      } else {
        this.router.navigate([item.URL]);
      }
      this.onColapseAll.emit();
    }
    this.navigationService.toggleNav(false);
  }

  openNewAngular(url: string) {
    window.open(`${environment.EXTERNAL_BASE_URL}/${url}`, '_self');
  }

  /**
   * @returns True: Acceso denegado a módulo de créditos debido a que no tiene usuario saf asignado.
   * @returns False: Acceso permitido a módulo de créditos ya que posee un usuario saf asignado.
   */
  checkCreditAccessPermissions(): boolean{
    const token = localStorage.getItem('token') as string;
    const jwtDecoded = jwt_decode(token);
    let accessDenied = false;
    
    if(!jwtDecoded.userSAF){
      accessDenied = true;
      const config = new MdDialogConfig();
      config.panelClass = 'new-dialog-pannel-custom'
      this.dialog.open(CreditNotConfiguredDialogComponent, config);
    }

    return accessDenied;
  }
}

export interface SideMenuItem {
  id: string;
  MainName: string;
  MainIconName: string;
  MainIconSVGName: string;
  MainURL: string[];
  Subtree: SideMenuSubtreeItem[];
  IsNewAngularURL: boolean;
  open: boolean;
  bubble: boolean;
  allowed: boolean;
  jdeAllowed: boolean;
}

export interface SideMenuSubtreeItem {
  id: string;
  Name: string;
  URL: string;
  IconName: string;
  SVGIconName: string;
  bubble: boolean;
  allowed: boolean;
  extraIconClasses?: string;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/side-menu-list-item/side-menu-list-item.component.ts